import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Skeleton } from 'antd';
import config from '../../settings/config.json';
import { Pagination } from 'antd';

function PoetryPage() {
  const [currentPage, setCurrentPage] = useState(1);
  const [poems, setPoems] = useState([]);
  const [totalPoems, setTotalPoems] = useState(0);
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        setSettings(response.data[0]);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchSettings();
    
    const interval = setInterval(fetchSettings, 5000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchPoems = async () => {
      try {
        const response = await axios.get(`/api/poems`);
        setPoems(response.data);
        setTotalPoems(response.data.length);
      } catch (error) {
        console.error('Error fetching poems:', error);
      }
    };

    fetchPoems();
    const interval = setInterval(fetchPoems, 3000);
    return () => clearInterval(interval);
  }, []);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const currentPoem = poems[currentPage - 1];

  return (
    <div className='PoetryPage'>
      <div className='background-image'>
        <br /><br /><br /><br /><br />
        <div>
          <center>
            <h1>
              <i className="fa-solid fa-pen-nib text-gradient"></i> {settings?.client?.poetryPage?.title ? settings?.client?.poetryPage?.title : ''}
            </h1>
            <h3 className='font-reqular text-secondary'>{settings?.client?.poetryPage?.description ? settings?.client?.poetryPage?.description : <Skeleton active />}</h3>
            <br/>
            <div className='red-divider'></div>
          </center>
          <br/>
          <div>
            {currentPoem ? (
              <>
                <center><img src={`/api${currentPoem.photo}`} width='100px' height='100px' className='ggh' /></center>
                <center className='mt-2'><span className='text-secondary font-reqular fs-6'>{currentPoem.name} </span></center>
                <br/>
                <div className='d-flex justify-content-center'>
                  <center><div className='font-reqular animp spaces' dangerouslySetInnerHTML={{ __html: currentPoem.content }} /></center>
                </div>

                {currentPoem.audio ? (
                  <>
                  <br/>
                    <div className=''>
                      <center>
                      <audio src={`/api${currentPoem.audio}`} controls />
                      <br />
                      <h6 className='text-gradient-two font-reqular'>Səs: {currentPoem.speaker}</h6>
                      </center>
                    </div>
                  </>
                ) : (
                  <div></div>
                )}

                <br/>
                <div className='d-flex justify-content-center'>
                  <Pagination 
                    current={currentPage}
                    onChange={handlePageChange}
                    total={totalPoems}
                    pageSize={1}
                  />
                </div>
              </>
            ) : (
              <center className='mt-5'>
                <h2 className='text-gradient'>Oops...</h2>
                <h4 className='mt-3 text-secondary font-reqular'>Şeir yoxdur</h4>
                <br /><br /><br />
              </center>
            )}
          </div>
          <br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/><br/>
        </div>
      </div>
    </div>
  );
}

export default PoetryPage;
